module.exports = "<listado-general \r\n[listado]=\"channels\" \r\n[titulo]=\"'Channels'\" \r\n[urladicional]=\"'/home'\" \r\n[leyendaListado]=\"'DEFAULT_LEYENDA_HOME' | translate\">\r\n</listado-general>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/sistema.component.html
// module id = ../../../../../src/app/private/configuracion/sistema.component.html
// module chunks = main